import { useState } from "react";
import { FileDown } from "lucide-react";
import { http, toastApiError } from "../../lib/api";
import { toast } from "../../lib/notify";

// Excel yüklemesinden sonra hatalı satırları (yüklenen dosyanın sütunlarıyla + Hata + Excel Satırı) indirir — düzeltip yeniden yüklenebilir
export default function UploadErrorsButton({ file, errors, name = "Yükleme", testid = "upload-errors-xlsx", className = "" }) {
  const [busy, setBusy] = useState(false);
  if (!file || !errors?.length) return null;
  const download = async () => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("errors", JSON.stringify(errors));
      fd.append("title", name);
      const res = await http.post("/uploads/errors-xlsx", fd, { headers: { "Content-Type": "multipart/form-data" }, responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: `${name.toLocaleLowerCase("tr").replace(/[^a-z0-9ğüşıöç]+/g, "-")}-hatali-satirlar-${new Date().toISOString().slice(0, 10)}.xlsx` });
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
      toast.success(`${errors.length} hatalı satır Excel'e indirildi — düzeltip yeniden yükleyebilirsiniz`);
    } catch (e) { toastApiError(e); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={download} disabled={busy} data-testid={testid} title="Yalnız hatalı satırlar, dosyanızın sütunları + Hata sütunuyla; düzeltip aynı yerden yeniden yükleyin"
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md border border-red-700 bg-white text-red-800 text-[11px] font-semibold hover:bg-red-100 disabled:opacity-50 ${className}`}>
      <FileDown className="w-3.5 h-3.5" /> {busy ? "Hazırlanıyor…" : `Hatalı Satırları İndir (${errors.length})`}
    </button>
  );
}
